import './index.less';
import React from 'react';

const Footer=() =>{
    return (
        <div className="footer">备案证号：京ICP备08010314号-6  Copyright©2005-2018 360.com 版权所有 360互联网安全中心</div>
    )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/component/footer/index.jsx